module.exports = __webpack_public_path__ + "static/media/reference-slider-13.caa65bd8.jpg";